// extracted by mini-css-extract-plugin
export default {"screenReaderOnly":"ky6t2"};